import { defaultLifeFormValues, LifeFormValues } from "./LifeFormValues";
import { BeneficiaryFormValues, defaultBeneficiaryFormValues } from "../common/BeneficiaryFormValues";

export type LifeBeneficiaryFormValues = BeneficiaryFormValues & LifeFormValues & {}

export const defaultLifeBeneficiaryFormValues = {
    ...defaultBeneficiaryFormValues,
    ...defaultLifeFormValues
}